import React from "react";
import { useI18n } from "../context/I18nContext";
import { Check, X, ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";
import { Link } from "react-router-dom";

export default function Model() {
  const { t, lang } = useI18n();
  return (
    <div>
      <section className="section border-b border-slate-200">
        <div className="container-page grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7">
            <div className="label-divider mb-6">{lang === "fr" ? "Notre modèle" : "Our model"}</div>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight text-slate-900" data-testid="model-title">
              {t.model.title}
            </h1>
            <p className="mt-6 text-lg text-slate-600 max-w-2xl">{t.model.subtitle}</p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container-page grid grid-cols-1 md:grid-cols-2 gap-px bg-slate-200 border border-slate-200">
          {t.model.steps.map((s, i) => (
            <div key={i} className="bg-white p-8" data-testid={`model-step-${i}`}>
              <div className="font-mono text-xs text-emerald-700 font-semibold">{s.n}</div>
              <h3 className="mt-3 font-display text-xl font-semibold text-slate-900">{s.t}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section bg-slate-50 border-t border-slate-200">
        <div className="container-page grid md:grid-cols-2 gap-10">
          <div>
            <div className="label-divider mb-4 !text-emerald-700">{lang === "fr" ? "Ce que nous faisons" : "What we do"}</div>
            <ul className="space-y-3">
              {t.model.do.map((d, i) => (
                <li key={i} className="flex items-start gap-3 text-slate-800">
                  <Check className="h-5 w-5 text-emerald-700 mt-0.5 shrink-0" />
                  <span>{d}</span>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <div className="label-divider mb-4 !text-slate-800">{lang === "fr" ? "Ce que nous ne faisons pas" : "What we don't do"}</div>
            <ul className="space-y-3">
              {t.model.dont.map((d, i) => (
                <li key={i} className="flex items-start gap-3 text-slate-800">
                  <X className="h-5 w-5 text-slate-500 mt-0.5 shrink-0" />
                  <span>{d}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-16">
          <Button asChild size="lg" className="rounded-sm bg-slate-900 hover:bg-slate-800" data-testid="model-cta-invest">
            <Link to="/invest">{t.invest.title} <ArrowRight className="h-4 w-4 ml-2" /></Link>
          </Button>
        </div>
      </section>
    </div>
  );
}
